export default __webpack_public_path__ + "static/media/Megosu-Made.com-GIF.cfcce519.png";